import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircle2, ShieldCheck, BookOpen, Plus } from 'lucide-react';
import './FormSuccessPage.css';

export default function FormSuccessPage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  return (
    <div className="success-shell">
      <div className="success-card fade-in">
        <div className="success-logo">
          <ShieldCheck size={15} strokeWidth={2} />
          <span>UFL HSE</span>
        </div>
        <div className="success-icon">
          <CheckCircle2 size={40} strokeWidth={1.5} />
        </div>
        <h2 className="success-title">Observation Submitted</h2>
        <p className="success-msg">
          Your observation has been recorded successfully. Thank you for contributing to a safer workplace.
        </p>
        <div className="success-actions">
          <a href={`/submit/${slug}/form`} className="success-btn primary">
            <Plus size={14} />
            Submit Another Observation
          </a>
          <button 
            className="success-btn secondary"
            onClick={() => navigate(`/submit/${slug}`)}
          >
            <BookOpen size={14} />
            Go Back Home
          </button>
        </div>
      </div>
    </div>
  );
}
